function Yemen({ dimensions, col = '#000' }) {
  const baseXml = `
  <svg width=${dimensions || 24} height=${dimensions || 24} viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
  <g clip-path="url(#clip0_521_2560)">
  <path d="M16 32C24.8366 32 32 24.8366 32 16C32 7.16344 24.8366 0 16 0C7.16344 0 0 7.16344 0 16C0 24.8366 7.16344 32 16 32Z" fill="#F0F0F0"/>
  <path d="M16 31.9993C22.8795 31.9993 28.7442 27.6573 31.0049 21.5645H0.995239C3.25593 27.6573 9.12061 31.9993 16 31.9993Z" fill="black"/>
  <path d="M16 0C9.12061 0 3.25593 4.342 0.995239 10.4348H31.0049C28.7442 4.342 22.8795 0 16 0Z" fill="#D80027"/>
  </g>
  </svg>
  `;

  return baseXml;
}

export default Yemen;
